// src/pages/app/ProfilePage.jsx
import React from 'react';
import DashboardLayout from '../../layouts/DashboardLayout'; 

const ProfilePage = () => {
    const handleSave = () => {
        alert('Profile saved successfully!');
    };

    return (
        <DashboardLayout>
            <h1 className="dashboard-page-title">My Profile</h1>
            <p className="dashboard-page-subtitle">Manage your personal details and neighborhood settings.</p>
            
            <div className="widget profile-form-widget" style={{ maxWidth: '700px' }}>
                <h3 className="widget-title">Personal Information</h3>
                
                <form style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                    
                    {/* First Column */}
                    <div>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Full Name</label>
                        <input type="text" defaultValue="John Doe" className="auth-input-field" style={{ marginBottom: '15px' }} />
                        
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Email</label>
                        <input type="email" defaultValue="johndoe@email.com" className="auth-input-field" disabled style={{ backgroundColor: '#f5f5f5', marginBottom: '15px' }} />
                        
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Password</label>
                        <input type="password" defaultValue="********" className="auth-input-field" />
                        <button className="auth-button auth-google-button" style={{ marginTop: '10px', padding: '8px', fontSize: '14px' }}>Change Password</button>
                    </div>

                    {/* Second Column: Location/Verification */}
                    <div>
                        <h4 style={{ color: 'var(--color-navy)', borderBottom: '1px solid #eee', paddingBottom: '5px', marginTop: '0' }}>Location & Verification</h4>
                        
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Verified Borough</label>
                        <select className="auth-input-field" style={{ marginBottom: '15px' }}>
                            <option>Manhattan</option>
                            <option>Brooklyn</option>
                            <option>Queens</option>
                        </select>
                        
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>Neighborhood</label>
                        <input type="text" defaultValue="Upper East Side" className="auth-input-field" />
                        
                        <p style={{ fontSize: '0.85rem', color: 'var(--color-sky)', marginTop: '5px' }}>
                            Your profile is **Verified** [Checkmark]
                        </p>
                    </div>
                </form>
                
                <div style={{ borderTop: '1px solid #eee', marginTop: '30px', paddingTop: '20px', textAlign: 'right' }}>
                    <button 
                        onClick={handleSave} 
                        className="auth-button auth-primary-button" 
                        style={{ width: '150px' }}
                    >
                        Save Changes
                    </button>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default ProfilePage;